import Menu from './Compartido/Menu.jsx';
import TextoProtocolos from './Protocolos/TextoProtocolos.jsx';
import Footer from './Compartido/Footer.jsx';

const Protocolos = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextoProtocolos
                protocolos={props.textoprotocolos}
                ruta={props.ruta}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Protocolos;
